import Image from 'next/legacy/image'
import React from 'react'
import type { DiscussionPostResult } from '../data/fragments/DiscussionPostFragment'
import { Box } from './Box'
import { Button } from './Buttons'
import styles from './Comments.module.sass'
import { Flex } from './Flex'
import { Gallery } from './Gallery'

export function Comments(props: { comments: DiscussionPostResult[] }) {
	const [toggleAll, setToggleAll] = React.useState<boolean>(false)

	return (
		<div className={styles.wrapper}>
			<div className={styles.inner}>
				<Flex itemsPerRow={3} spacing={10} alignItems="flex-start" justifyContent="flex-start">
					{props.comments.map((item, index) => {
						if (toggleAll || index < 3) {
							return (
								<Box key={index}>
									<div className={styles.comment}>
										<div className={styles.author}>
											<div className={styles.authorImage}>
												{item.author?.avatar && (
													<Image
														src={item.author?.avatar?.url}
														layout="fill"
														objectFit="cover"
														alt={item.author?.avatar?.alt ?? item.author?.avatar?.description ?? ''}
														placeholder="blur"
														blurDataURL={item.author?.avatar?.url}
													/>
												)}
											</div>
											<h5>{item.author?.nick}</h5>
										</div>
										<p>{item.text}</p>
										{item.images?.items && <Gallery items={item.images.items} />}
									</div>
								</Box>
							)
						}
					})}
				</Flex>
			</div>
			<Button
				fill="grey100"
				type="button"
				onClick={() => {
					setToggleAll((old) => !old)
				}}>
				{toggleAll ? 'Show less' : `View all comments (${props.comments.length})`}
			</Button>
		</div>
	)
}
